@let memberDataValue = memberData();

<rt-dialog-header>
  <tlc-edit-member-header
    [avatarThumbUrl]="memberDataValue?.avatarThumbUrl!"
    [isOwner]="memberDataValue?.owner!"
    [email]="memberDataValue?.firstName || memberDataValue?.lastName ? memberDataValue?.email! : ''"
    [isDeactivated]="memberDataValue?.status === TeamMemberStatus.Deactivated"
    [memberGuid]="memberDataValue?.guid!"
  />
</rt-dialog-header>

<rt-dialog-body variant="white" layout-vertical>
  @if (!isOwner() && !isSelf()) {
    <div class="description" margin-bottom>
      {{ 'tlc.members.edit_member.permission_tab.description' | translate }}
    </div>
  } @else if (isOwner()) {
    <rt-infobox
      [iconName]="'info-outline'"
      [heading]="'tlc.members.edit_member.permission_tab.infobox.heading' | translate"
      [isDismissible]="false"
      [rounded]="true"
      margin-bottom
    >
      <div>{{ 'tlc.members.edit_member.permission_tab.infobox.description' | translate }}</div>
    </rt-infobox>
  } @else if (isSelf()) {
    <!-- TODO: Copy -->
    <rt-infobox
      [iconName]="'info-outline'"
      [heading]="'tlc.members.edit_member.permission_tab.infobox_self.heading' | translate"
      [isDismissible]="false"
      [rounded]="true"
      margin-bottom
    >
      <div>{{ 'tlc.members.edit_member.permission_tab.infobox_self.description' | translate }}</div>
    </rt-infobox>
  }

  @if (memberData() && adminData()) {
    <tla-edit-member-permissions
      [admin]="adminData()!"
      [member]="memberData()!"
      (valueChanges)="handleValueChange($event)"
      (statusChanges)="handleStatusChange($event)"
      (selectedGroupChanges)="handleSelectedGroupChange($event)"
    />
  }
</rt-dialog-body>
<rt-dialog-footer variant="white">
  <rt-button variant="plain" (click)="cancel()">{{ 'tlc.common.cancel' | translate }}</rt-button>
  <rt-button
    class="form-button"
    [disabled]="state().disabled || isEmptyAdministrativeAccess()"
    (click)="submit(state().value)"
    [loading]="pending()"
    variant="primary"
    >{{ 'tlc.common.save' | translate }}</rt-button
  >
</rt-dialog-footer>
